import { RequestServiceCodeRepoImpl } from "domain/repository/RequestServiceCode/RequestServiceCodeRepoImpl";
import { useRequestServiceCodeTracked } from "presentation/store/RequestServiceCode/RequestServiceCodeProvider";
import { RequestServiceCodeVM } from "presentation/viewModel/RequestServiceCode/RequestServiceCodeVM";
import { useMemo } from "react";

export const useRequestServiceCodeVM = () => {
    const [, setRequestServiceCodeState] = useRequestServiceCodeTracked();
    const requestServiceCodeVM = useMemo(() =>
        RequestServiceCodeVM({
            dispatch: [setRequestServiceCodeState],
            repo: RequestServiceCodeRepoImpl(),
        }), [setRequestServiceCodeState])

    return requestServiceCodeVM
}